import { useBreakpoint } from '@orn/shared-web/hooks/useBreakpoint';
import * as React from 'react';

type UseBreakpointsResult = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

/**
 * Returns booleans and the current label for the active responsive breakpoint.
 */
export const useDeviceBreakpoints = (): UseBreakpointsResult => {
  const isTabletAndUp = useBreakpoint('md'); // 768px
  const isDesktop = useBreakpoint('lg'); // 1024px

  const result = React.useMemo<UseBreakpointsResult>(() => {
    return {
      isDesktop,
      isTablet: isTabletAndUp && !isDesktop,
      isMobile: !isTabletAndUp && !isDesktop,
    };
  }, [isDesktop, isTabletAndUp]);

  return result;
};
